import apiClient from '../utils/apiClient';

const base = (facilityId) => `/api/facilities/${facilityId}/integrations`;

const integrationsService = {
  list: (facilityId) => apiClient.get(`${base(facilityId)}/`),
  get: (facilityId, provider) => apiClient.get(`${base(facilityId)}/${provider}`),
  saveQuickBooks: (facilityId, data) => apiClient.put(`${base(facilityId)}/quickbooks`, data),
  remove: (facilityId, provider) => apiClient.delete(`${base(facilityId)}/${provider}`),
  testQuickBooks: (facilityId) => apiClient.post(`${base(facilityId)}/quickbooks/test`, {}),
  authorizeQuickBooks: (facilityId) => apiClient.get(`${base(facilityId)}/quickbooks/authorize`),
  // QB Phase 1 — read-only data pull (no import). entity ∈ Customer/Invoice/
  // Payment/Account/Item/Vendor/Bill/CompanyInfo.
  readQuickBooks: (facilityId, entity = 'Customer', limit = 50) =>
    apiClient.get(`${base(facilityId)}/quickbooks/read`, { params: { entity, limit } }),
  // QB TRUE accounting sync (one-way mySMS360 -> QBO)
  qbSyncStatus: (facilityId) =>
    apiClient.get(`${base(facilityId)}/quickbooks/sync-status`),
  qbSaveSyncSettings: (facilityId, accountMap, enabled) =>
    apiClient.put(`${base(facilityId)}/quickbooks/sync-settings`,
      { account_map: accountMap, enabled }),
  qbBackfill: (facilityId, since, mode) =>
    apiClient.post(`${base(facilityId)}/quickbooks/backfill`, null,
      { params: { since, mode } }),
  qbMatchPreview: (facilityId) =>
    apiClient.get(`${base(facilityId)}/quickbooks/match-preview`),
  qbMatchCommit: (facilityId, matches) =>
    apiClient.post(`${base(facilityId)}/quickbooks/match-commit`, { matches }),
  qbSyncRun: (facilityId) =>
    apiClient.post(`${base(facilityId)}/quickbooks/sync-run`),
  qbSyncRetry: (facilityId, queueId) =>
    apiClient.post(`${base(facilityId)}/quickbooks/sync-retry/${queueId}`),
};

export default integrationsService;
